import React, { useState } from 'react';
import Cookies from 'js-cookie';
import config from '../functions/config';

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    current_password: '',
    new_password: '',
  });

  const sessionId = Cookies.get('sessionid'); // Fetch session ID from cookies
  console.log('Session ID:', sessionId); // Debugging session ID

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!sessionId) {
      alert('Session ID is missing. Please log in again.');
      return;
    }

    try {

      const response = await fetch(`${config.BASE_URL}/api/change-password/`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'X-Session-ID': sessionId, // Pass session ID from cookies
          },
          body: JSON.stringify(formData),
      });
      
      if (response.ok) {
        alert('Password changed successfully!');
        setFormData({ current_password: '', new_password: '' });
      } else {
        const data = await response.json();
        alert(`Error: ${data.error}`);
      }
    } catch (err) {
      console.error('Error changing password:', err);
    }
  };

  return (
    <div>
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">Library Management</a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
            <li className="nav-item">
                <a className="nav-link" href="/success">
                   Books
                </a>
              </li>
            <li className="nav-item">
                <a className="nav-link" href="/userhome">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/profile">Profile</a>
              </li>
            
              <li className="nav-item">
                <a className="nav-link" href="/rentalhistory">Rented Books</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/purchasehistory">Purchase History</a>
              </li>
              <a href="/login" class="btn btn-danger">Logout</a>

            </ul>
          </div>
        </div>
      </nav>
    <div className="container my-5">
      <h2>Change Password</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="current_password" className="form-label">
            Current Password
          </label>
          <input
            type="password"
            id="current_password"
            name="current_password"
            value={formData.current_password}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="new_password" className="form-label">
            New Password
          </label>
          <input
            type="password"
            id="new_password"
            name="new_password"
            value={formData.new_password}
            onChange={handleChange}
            className="form-control"
            required
          />
        </div>
        <button type="submit" className="btn btn-primary">
          Change Password
        </button>
      </form>
    </div>
    </div>
  );
};

export default ChangePassword;
